import { type OrganizationState } from "@decentriq/graphql/dist/types";
import { testIds } from "@decentriq/utils";
import { Stack } from "@mui/joy";
import { type MRT_TableInstance } from "material-react-table";
import { memo, useCallback } from "react";
import { OrganizationsAddButton } from "components";
import { EntitiesSearch, ExportAsCsvButton } from "components/base";
import { type Organization } from "./models";
import OrganizationStateFilter from "./OrganizationStateFilter";

interface OrganizationsToolbarProps {
  setOrganizationStateFilter: (state: OrganizationState | null) => void;
  organizationStateFilter: OrganizationState | null;
  onSearchChange: (value: string) => void;
  searchValue: string;
  table: MRT_TableInstance<Organization>;
  hasData: boolean;
}

const getHeaders = () => ["Id", "License", "Name"];

const OrganizationsToolbar = memo<OrganizationsToolbarProps>(
  ({
    setOrganizationStateFilter,
    organizationStateFilter,
    onSearchChange,
    searchValue,
    table,
    hasData,
  }) => {
    const getRows = useCallback(() => {
      return table.getPaginationRowModel().rows.map((row) => {
        const { id, state, name } = row.original;
        return [id, state, name];
      });
    }, [table]);
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        spacing={2}
        width="100%"
      >
        <Stack direction="row">
          <OrganizationStateFilter
            onChange={(value) => setOrganizationStateFilter(value)}
            value={organizationStateFilter}
          />
          <Stack sx={{ width: "280px" }}>
            <EntitiesSearch
              onChange={(event) => onSearchChange(event.target.value)}
              onClear={() => onSearchChange("")}
              placeholder="Search organizations"
              testId={testIds.adminPortal.organizations.search}
              value={searchValue}
            />
          </Stack>
        </Stack>
        <Stack direction="row">
          {hasData ? (
            <ExportAsCsvButton
              fileName="organizations.csv"
              getHeaders={getHeaders}
              getRows={getRows}
            />
          ) : null}
          <OrganizationsAddButton />
        </Stack>
      </Stack>
    );
  }
);

OrganizationsToolbar.displayName = "OrganizationsToolbar";

export default OrganizationsToolbar;
